import clsx from "clsx";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { ACTIVITY_TYPES, OCCUPANCY_TYPES, VALET_OCCUPANCY_TYPES } from "../../../constants";
import {
  clearActivityFilters,
  setActivityType,
  setCredentialType
} from "../../../state/slices/filters/activity";
import SingleSelectDropdown from "../../Dropdowns/SingleSelect";
import SquareChip from "../../SquareChip";
import { useStyles } from "./styles";
import React from "react";

const ActivityFilters = ({ onChange, isValetAreaEntity, ...props }) => {
  const classes = useStyles();
  const activityFilters = useSelector(state => state.activity);
  const dispatch = useDispatch();

  const facilityOccupancyTypes = [
    { name: "All", value: "" },
    { name: "Transient", value: OCCUPANCY_TYPES.Transient },
    { name: "Contract", value: OCCUPANCY_TYPES.Contract }
  ];

  const valetOccupancyTypes = [
    { name: "All", value: "" },
    { name: "Transient", value: VALET_OCCUPANCY_TYPES.Transient }
  ];

  const facilityActivityTypes = [
    { name: "All", value: "" },
    { name: "Enter", value: ACTIVITY_TYPES.Enter },
    { name: "Exit", value: ACTIVITY_TYPES.Exit },
    { name: "Payment", value: ACTIVITY_TYPES.Payment },
    { name: "Pay On Entry", value: ACTIVITY_TYPES.PayOnEntry }
  ];

  const valetActivityTypes = [
    { name: "All", value: "" },
    { name: "Valet Arrival", value: ACTIVITY_TYPES.ValetArrival },
    { name: "Payment", value: ACTIVITY_TYPES.Payment },
    { name: "Valet Request", value: ACTIVITY_TYPES.ValetRequest },
    { name: "Valet Retrieval", value: ACTIVITY_TYPES.ValetRetrieval },
    { name: "Valet Delivery", value: ACTIVITY_TYPES.ValetDelivery },
    { name: "Refund", value: ACTIVITY_TYPES.Refund },
    { name: "Unsuccessful Refund", value: ACTIVITY_TYPES.UnsuccessfulRefund }
  ];

  const occupancyTypes = isValetAreaEntity ? valetOccupancyTypes : facilityOccupancyTypes;
  const activityTypes = isValetAreaEntity ? valetActivityTypes : facilityActivityTypes;

  const handleCredentialSelectChange = value => {
    dispatch(setCredentialType(value));
    onChange();
  };

  const handleActivitySelectChange = value => {
    dispatch(setActivityType(value));
    onChange();
  };

  const handleClearFilters = () => {
    dispatch(clearActivityFilters());
    onChange();
  };

  return (
    <>
      <div className={classes.filterRoot}>
        <div className={classes.activityTypeContainer}>
          <SingleSelectDropdown
            name="Credential Type"
            className={clsx(
              "credential-type-dropdown",
              classes.activityTypeDropdown
            )}
            options={occupancyTypes}
            onSelect={handleCredentialSelectChange}
            value={activityFilters.CredentialType ?? "unset"}
          />
        </div>
        <div className={classes.activityTypeContainer}>
          <SingleSelectDropdown
            name="Activity Type"
            className={clsx(
              "activity-type-dropdown",
              classes.activityTypeDropdown
            )}
            options={activityTypes}
            onSelect={handleActivitySelectChange}
            value={activityFilters.ActivityType ?? "unset"}
          />
        </div>
        <SquareChip
          className={clsx("clear-filters-button", classes.clearFilterBtn)}
          data-id="clear-filters"
          text="Clear Filters"
          onClick={handleClearFilters}
          mode="red"
        />
      </div>
    </>
  );
};

ActivityFilters.defaultProps = {
  onChange: () => {},
  isValetAreaEntity: false
};

ActivityFilters.propTypes = {
  onChange: PropTypes.func,
  isValetAreaEntity: PropTypes.bool
};

export default ActivityFilters;
